import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { SingleSelectItem } from '../single-select/single-select-item';
import { UserService } from '../../../service/user/user.service';
import { User } from '../../../model/user/user';

@Component({
  selector: 'nec-year-select',
  templateUrl: './year-select.component.html'
})
export class NecYearSelectComponent implements OnInit {
  years: SingleSelectItem[];
  selectedYear: SingleSelectItem;
  user: User;

  @Output() selectedYearChange = new EventEmitter();

  constructor(private userService: UserService) {
    this.years = [];
    this.user = this.userService.getUserInfo();
  }

  ngOnInit() {
    let nowYear;
    // // ä¼åéè¿å½åç¨æ·æè¿ç»å½æ¶é´ä½ä¸ºå½åçå¹´ä»½ï¼è¯¯å·®è¾å°ï¼
    //     // if (this.user && this.user.me) {
    //     //   let date = new Date();
    //     //   date.setTime(this.user.me.lastLogin);
    //     //   nowYear = date.getFullYear();
    //     // } else {
    //     //
    //     // }
    nowYear = new Date().getFullYear();

    for (let i = nowYear + 1; i >= 2016; i--) {
      this.years.push(new SingleSelectItem(i, i.toString()));
    }

    // éä¸­å½åå¹´
    this.selectedYear = this.years[1];
  }

  onYearChange(event) {
    this.selectedYearChange.emit(event.data);
  }
}
